export const PROJECT_TYPE_TITLE = 'Project Type:'
export const TIME_TITLE = 'Time:'
export const PROGRAM_THEMES_TITLE = 'Program Themes:'
